import { inject, Injectable } from '@angular/core'
import type { Observable } from 'rxjs'
import { forkJoin } from 'rxjs'

import { _Record } from '@app/core/record'
import { HttpService } from '@app/services/http.service'

import type {
  GetPhotosParams,
  GetPhotosResponse,
  MessagePhotoAlbumSection,
  UploadPhotosParams,
  UploadPhotosResponse,
} from '../models/api.model'
import { MESSAGE_PHOTO_ALBUM_SECTIONS } from '../models/api.model'

@Injectable({ providedIn: 'root' })
export class MessagePhotoAlbumService {
  private readonly httpService = inject(HttpService)

  getPhotos({ page, type }: GetPhotosParams): Observable<GetPhotosResponse> {
    return this.httpService.get<GetPhotosResponse>('message_album_photos', { params: { page, type } })
  }

  uploadPhotos(params: UploadPhotosParams): Observable<UploadPhotosResponse> {
    return this.httpService.post<UploadPhotosResponse>('/message_album_photos', params)
  }

  removePhotos(ids: number[]): Observable<unknown> {
    return this.httpService.post('/message_album_photos/remove', { photo_ids: ids })
  }

  load(): Observable<Record<MessagePhotoAlbumSection, GetPhotosResponse>> {
    return forkJoin(_Record.fromKeysWithMap(MESSAGE_PHOTO_ALBUM_SECTIONS, type => this.getPhotos({ page: 1, type })))
  }
}
